import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { FormActionsComponent } from '@shared/components/form-actions/form-actions.component';
import { EMAIL } from '@util/regex';

export interface IndexedLearnerAttributes extends AddLearnerAttributes {
  index?: number;
  missingContactInformation?: boolean;
}

export interface AddLearnerAttributes {
  firstName: string;
  lastName: string;
  email?: string;
  mobileNumber?: string;
  organizationIds: string[];
}

@Component({
  selector: 'vnm-add-learners-step',
  templateUrl: './add-learners-step.component.html',
  styleUrls: ['./add-learners-step.component.scss', '../wizard-step-footer-message.scss']
})
export class AddLearnersStepComponent {
  @ViewChild(FormActionsComponent) formActions: FormActionsComponent;

  @Input() learners: IndexedLearnerAttributes[] = [];
  @Input() requireContactMethod = false;
  @Input() maxAdd: number; // Optional
  @Input() tooManyLearnersMessage: string; // Provide this if you use maxAdd
  @Input() learnerI18nNamespace = 'learners';
  @Input() nextStepLabel = 'add-learners-wizard.confirm-learners';

  @Output() learnersChange = new EventEmitter<IndexedLearnerAttributes[]>();
  @Output() learnersAdded = new EventEmitter<IndexedLearnerAttributes[]>();
  @Output() cancel = new EventEmitter();
  @Output() nextStep = new EventEmitter();

  learnerForm = this.fb.group({
    firstName: [null, Validators.required],
    lastName: [null, Validators.required],
    email: [null, [Validators.email]],
    mobileNumber: [null]
  });
  emailPattern = EMAIL;

  constructor(private fb: UntypedFormBuilder) {}

  addLearner(_event: Event) {
    this.addLearners([this.learnerForm.value]);
    this.formActions.reset({});
  }

  addLearners(learners: AddLearnerAttributes[]) {
    const indexedLearners = learners.map((learner, index) => {
      const indexedLearner = {
        index: this.learners.length + index,
        ...learner
      };

      return indexedLearner;
    });

    this.learners = [...this.learners, ...indexedLearners];
    this.learnersChange.emit(this.learners);
    this.learnersAdded.emit(this.learners);
  }

  onRemove(learner: IndexedLearnerAttributes) {
    for (let i = learner.index + 1; i < this.learners.length; i++) {
      const learner = this.learners[i];
      learner.index -= 1;
    }

    this.learners.splice(learner.index, 1);
    this.learnersChange.emit(this.learners);
  }
}
